import React from "react";
import { NavLink } from "react-router-dom";

export class SettingsNav extends React.Component {
  render() {
    return (
      <div className="nav flex-column nav-pills">
        <NavLink to={"/settings/general"} activeClassName={"active"} className="nav-link">General</NavLink>
        <NavLink to={"/settings/myob"} activeClassName={"active"} className="nav-link">MYOB</NavLink>
        <NavLink to={"/settings/xero"} activeClassName={"active"} className="nav-link">Xero</NavLink>
        <NavLink to={"/settings/holidays"} activeClassName={"active"} className="nav-link">Holidays</NavLink>
        <NavLink to={"/settings/reporting"} activeClassName={"active"} className="nav-link">Reporting</NavLink>
        <NavLink to={"/settings/password"} activeClassName={"active"} className="nav-link">Password</NavLink>
      </div>
    );
  }
}